import { render, staticRenderFns } from "./InstructionCardsList.vue?vue&type=template&id=0faf28bb&"
import script from "./InstructionCardsList.vue?vue&type=script&lang=js&"
export * from "./InstructionCardsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InstructionCard: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/InstructionCard/InstructionCard.vue').default})
